import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const NOTES_RECOMMENDATIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SEVERITIES_AND_CARDS: '/admin/severities-and-cards/',
    RETRIEVE: (orderID: number) => `/admin/order-notes-recommendations/retrieve/${orderID}`,
    CREATE: (orderID: number) => `/admin/order-notes-recommendations/create/${orderID}`,
    DELETE: (noteID: number) => `/admin/order-notes-recommendations/delete/${noteID}`,
  }),
} as const;
